import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';
import PrimaryButton from 'v-c/Buttons/PrimaryButton';
import SecondaryButton from 'v-c/Buttons/SecondaryButton';

import ModalButtonSpacer from './ModalButtonSpacer';
import styles from './Modals.scss';

function ModalButtons(props) {
    return (<div className={styles['modal-buttons']}>
        {!!props.children && props.children}
        {!props.children && (
            <data>
                <PrimaryButton
                    onClick={props.onPrimaryClick}
                    data-action="primary-button-click"
                    disabled={props.primaryDisabled}
                >
                    {props.primaryText}
                </PrimaryButton>
                {props.secondaryText && <ModalButtonSpacer />}
                {props.secondaryText && (
                    <SecondaryButton onClick={props.onSecondaryClick} data-action="secondary-button-click">
                        {props.secondaryText}
                    </SecondaryButton>
                )}
            </data>
        )}
    </div>)
}

ModalButtons.displayName = displayName('Modals/ModalButtons');

ModalButtons.propTypes = {
    onPrimaryClick: PropTypes.func,
    onSecondaryClick: PropTypes.func,
    primaryText: PropTypes.node,
    secondaryText: PropTypes.node,
    children: PropTypes.node,
    primaryDisabled: PropTypes.bool,
};

ModalButtons.defaultProps = {
    primaryDisabled: false,
    onPrimaryClick: () => {},
    onSecondaryClick: () => {},
    primaryText: null,
    secondaryText: null,
    children: null,
};

export default ModalButtons;
